import { IStyle, theme } from '../../../ThemeContext/ThemeObject';

export const styles: IStyle = {
  expandedContentContainer: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    padding: theme.spacing(2),
    backgroundColor: 'background.paper',
    minWidth: '300px',
    flex: '1 1 300px'
  },
  scoreDisplayContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(0.5),
    borderRadius: 1
  }
};
